<script lang="ts" setup>
defineProps<{
    words: string[];
}>();

const emit = defineEmits<{
    select: [word: string];
}>();

const handleWordClick = (word: string) => {
    emit('select', word);
};
</script>

<template>
    <div class="hot-words-container">
        <span
            v-for="word in words"
            :key="word"
            class="hot-word-tag"
            @click="handleWordClick(word)"
        >
            {{ word }}
        </span>
    </div>
</template>

<style lang="scss" scoped>
@use './HotWords.scss';
</style>
